<div class="ccl-daterange" [class.ccl-daterange--disabled]="disabled">
  <label class="ccl-daterange__label">{{ label }}</label>

  <div class="ccl-daterange__field">
    <div class="ccl-daterange__display" (click)="openStartPicker()">
      @if (displayTemplate) {
        <ng-container
          *ngTemplateOutlet="displayTemplate; context: { range: { start: startDate, end: endDate } }"
        ></ng-container>
      } @else {
        {{ getRangeText() }}
      }
    </div>

    <button
      type="button"
      class="ccl-daterange__icon"
      aria-label="Open date range picker"
      [disabled]="disabled"
      (click)="openStartPicker($event)"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M7 11h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2zM6 3V1h2v2h8V1h2v2h2a2 2 0 012 2v14a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2zm14 16V8H4v11z"
        />
      </svg>
    </button>
    @if(startDate || endDate) {
      <button
        type="button"
        class="ccl-daterange__clear"
        aria-label="Clear date range"
        (click)="clearRange()"
        [disabled]="disabled"
      >
        ✕
      </button>
    }
  </div>

  <input
    #startPicker
    type="date"
    class="ccl-daterange__picker"
    [disabled]="disabled"
    [attr.min]="minSelectableDate ? getMinDateString() : null"
    [attr.max]="maxSelectableDate ? getMaxDateString() : null"
    (change)="onStartDateChange($event)"
  />

  <input
    #endPicker
    type="date"
    class="ccl-daterange__picker"
    [disabled]="disabled"
    [attr.min]="minSelectableDate ? getMinDateString() : null"
    [attr.max]="maxSelectableDate ? getMaxDateString() : null"
    (change)="onEndDateChange($event)"
  />
</div>

